import { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

export const getChannelColWidth = (
  isMobileVP: boolean, isTabletVP: boolean,
  isSinglePkgUseCase: boolean
) => ({
  ...(isMobileVP ? {
    flexBasis: isSinglePkgUseCase ? "116px" : "118px",
    width: isSinglePkgUseCase ? "116px" : "118px"
  } : isTabletVP ? {
    flexBasis: isSinglePkgUseCase ? "105px" : "25%",
    width: isSinglePkgUseCase ? "105px" : "25%"
  } : {
    flexBasis: "114px",
    width: "114px"
  })
});

export const getEmbeddedSvodColWidth = (isMobileVP: boolean, isTabletVP: boolean,
  isSinglePkgUseCase: boolean, _packagesLength: number) => ({
  ...(isMobileVP ? {
    flexBasis: isSinglePkgUseCase ?
      "calc((100% - 116px))" :
      `calc((100% - 118px))`,
    width: isSinglePkgUseCase ?
      "calc((100% - 116px))" :
      `calc((100% - 118px))`
  } : isTabletVP ? {
    flexBasis: isSinglePkgUseCase ?
      "calc((100% - 105px))" :
      `75%`,
    width: isSinglePkgUseCase ?
      "calc((100% - 105px))" :
      `75%`
  } : {
    flexBasis: `calc((100% - 114px)) !important`,
    width: `calc((100% - 114px)) !important`
  })
})

export const getMainColWidths = (
  isMobileVP: boolean, isTabletVP: boolean,
  isSinglePkgUseCase: boolean, packagesLength: number
) => ({
  ...(isMobileVP ? {
    flexBasis: isSinglePkgUseCase ?
      "calc((100% - 116px))" :
      `calc((100% - 118px) / ${packagesLength})`,
    width: isSinglePkgUseCase ?
      "calc((100% - 116px))" :
      `calc((100% - 118px) / ${packagesLength})`
  } : isTabletVP ? {
    flexBasis: isSinglePkgUseCase ?
      "calc((100% - 105px))" :
      `${75 / packagesLength}%`,
    width: isSinglePkgUseCase ?
      "calc((100% - 105px))" :
      `${75 / packagesLength}%`
  } : {
    flexBasis: `calc((100% - 114px) / ${packagesLength}) !important`,
    width: `calc((100% - 114px) / ${packagesLength}) !important`
  })
});

export const getStyles = (
  isChannelLineUpPage: boolean,
  isMobileVP: boolean, isTabletVP: boolean, isDesktopVP: boolean, theme?: any
) => ({
  tableBorder: {
    borderLeft: isChannelLineUpPage ? "none" : "1px solid transparent",
    borderRight: isChannelLineUpPage ? "none" : "1px solid transparent"
  },
  expandIconPosition: {
    "& .MuiAccordionSummary-expandIconWrapper": {
      alignSelf: "flex-start",
      margin: {
        md: "3px 0  !important",
        sm: "3px 0 !important",
        xs: "3px 0  !important"
      }
    }
  },
  showText: {
    display: "inline",
    position: "relative",
    bottom: "8px",
    fontSize: "14px !important",
    color: "#102641"
  },
  teamsContainer: {
    display: "flex",
    background: "#555555",
    textAlign: "left",
    color: "#FDF7F7",
    height: "26px",
    alignItems: "center"
  },
  channelName: {
    fontSize: "16px",
    fontWeight: 400,
    color: isChannelLineUpPage ? "white.main" : theme && theme?.grid?.textColor ? `${theme?.grid?.textColor} !important` : "#666666"
  },
  bgColorForChnlsLabel: {
    backgroundColor: isChannelLineUpPage ? "#102641" : "#ffffff"
  },
  icons12: {
    height: {
      xs: "30px",
      sm: "20px",
      md: "20px"
    },
    width: {
      sm: "20px",
      md: "20px"
    },
    verticalAlign: "middle",
    display: "inline-flex"
  },
  legendIcons: {
    height: "24px",
    width: "24px",
    verticalAlign: "middle",
    display: "inline-flex"
  },
  accordionSummary: {
    width: "100%",
    padding: "12px 20px !important",
    "& .MuiAccordionSummary-content": {
      margin: {
        md: "12px 0  !important",
        sm: "9px 0 !important",
        xs: "9px 0 !important"
      }
    },
    "& .DtvAccordionSummary-content": {
      margin: "0px !important"
    },
    zIndex: 998
  },
  addOnDiv: {
    paddingTop: "8px",
    paddingBottom: "8px",
    backgroundColor: isChannelLineUpPage ? "#FFFF" : theme && theme?.sectionHeaders?.backgroundColor ? theme?.sectionHeaders?.backgroundColor : "#D8E7F9",
    ...isMobileVP && {
      paddingBottom: "0px"
    }
  },
  promoDiv: {
    paddingTop: "8px",
    paddingBottom: "8px",
    backgroundColor: isChannelLineUpPage ? "#FFFF" : theme && theme?.sectionHeaders?.backgroundColor ? theme?.sectionHeaders?.backgroundColor : "#D8E7F9"
  },
  addOnPromoTextDiv: {
    paddingRight: {
      xs: "0px",
      md: "15px"
    },
    paddingLeft: {
      xs: "12.5px",
      md: "4px"
    }
  },
  maxWidth: {
    maxWidth: "100% !important"
  },
  addOnPkgName: {
    background: "#ffffff",
    paddingBottom: "8px",
    paddingTop: "8px",
    marginBottom: "8px"
  },
  infoSec: {
    display: "flex",
    ...(!isDesktopVP && {
      display: "flex !important",
      flexDirection: "column !important"
    })
  },
  channelRow: {
    backgroundColor: colorPalette.neutral_white.main,
    alignItems: "stretch",
    display: "flex",
    flex: "0 1 auto",
    height: "100%",
    width: "100%",
    zIndex: 0
  },
  accSummaryColor: {
    backgroundColor: isChannelLineUpPage ? "#FFFF" : theme ? theme?.sectionHeaders?.backgroundColor : "#D8E7F9",
    color: isChannelLineUpPage ? "jet.main" : theme ? theme?.sectionHeaders?.textColor : "#102641",
    "&.Mui-focusVisible": {
      backgroundColor: "#7A7A7A",
      "& p": {
        textDecoration: "underline"
      }
    }
  },
  highlightRowBgColor: {
    color: theme && theme?.grid?.highLightRowTextColor ? theme?.grid?.highLightRowTextColor : "#102641",
    backgroundColor: theme && theme?.grid?.highLightRowBackground ? theme?.grid?.highLightRowBackground : "#DADADA"
  },
  borderRow: {
    borderBottom: `1px solid ${isChannelLineUpPage ? "#D1D1D1" : theme && theme?.grid?.border ? theme?.grid?.border : "#D1D1D1"}`
  },
  borderHighlight: {
    border: `1px solid ${isChannelLineUpPage ? "#D1D1D1" : theme && theme?.grid?.border ? theme?.grid?.border : "#D1D1D1"}`
  },
  borderHighlightAcc: {
    borderLeft: `1px solid ${isChannelLineUpPage ? "#D1D1D1" : theme && theme?.grid?.border ? theme?.grid?.border : "#D1D1D1"}`,
    borderRight: `1px solid ${isChannelLineUpPage ? "#D1D1D1" : theme && theme?.grid?.border ? theme?.grid?.border : "#D1D1D1"}`
  },
  borderCol: {
    borderLeft: `${isChannelLineUpPage ? 1 : 1}px solid ${isChannelLineUpPage ? "#D1D1D1" : theme && theme?.grid?.border ? theme?.grid?.border : "#D1D1D1"}`
  },
  mb: {
    marginBottom: "0px"
  },
  marginRow: {
    marginBottom: "0px",
    marginLeft: "0px"
  },
  marginRowNoBottom: {
    marginLeft: "0px",
    marginBottom: "0px"
  },
  tablerowContainer: {
    margin: "0px !important",
    paddingTop: "0px !important"
  },
  tableColPad: {
    // paddingBottom: "0px !important",
    // paddingLeft: "0px !important",
    ...isTabletVP && {
      // paddingBottom: "0px !important",
    },
    ...isMobileVP && {
      padding: "0px 0px 4px 0px !important"
    }
  },
  tableColPadNew: {
    // paddingBottom: "0px !important",
    ...isTabletVP && {
      // paddingBottom: "0px !important",
    },
    ...isMobileVP && {
      padding: "0px 0px 4px 0px !important"
    }
  },
  tableLastCol: {
    ...isMobileVP && {
      padding: "0px 0px 4px 0px !important",
      paddingRight: isChannelLineUpPage ? "16px" : "0px !important"
    }
  },
  headerBold: {
    fontWeight: 500
  },
  paper: {
    backgroundColor: "transparent",
    color: "#666666",
    textAlign: "center"
  },
  icons: {
    display: "inline-flex",
    verticalAlign: "middle",
    height: "64px",
    width: "64px",
    // WAT-11362: contain so landscape OV logos aren't cropped (no-op for square logoUrl).
    objectFit: "contain"
  },
  icons1: {
    display: "inline-flex",
    verticalAlign: "middle",
    height: "32px",
    width: "32px",
    ...(!isDesktopVP && {
      height: "25px",
      width: "25px"
    })
  },
  textAlign: {
    height: isChannelLineUpPage && "100%",
    borderTopLeftRadius: isChannelLineUpPage && "5px",
    borderTopRightRadius: isChannelLineUpPage && "5px",
    ...(!isDesktopVP && {
      textAlign: "unset"
    })
  },
  headerPackageFontStyles: {
    color: "#666666",
    fontFamily: "roboto-medium",
    fontWeight: 500
  },
  headerNoOfChnls: {
    color: "#000000",
    fontSize: "14px",
    fontFamily: "roboto-regular",
    fontWeight: 400
  },
  headerNoOfChnlsInModal: {
    marginTop: "0px", // 16px
    ...(!isDesktopVP && {
      marginTop: "0px !important"
    })
  },
  hideCta: {
    display: "none !important"
  },
  imgCls1: {
    ...(!isDesktopVP && {
      marginTop: "0px"
    })
  },
  // Category
  categoryAccordion: {
    marginBottom: "2px !important",
    position: "inherit",
    ...isMobileVP && {
      marginBottom: "2px"
    }
  },
  accordionDetails: {
    backgroundColor: "#F2F2F2",
    paddingBottom: "0px",
    paddingLeft: "0px",
    paddingRight: "0px",
    paddingTop: "0px"
  },
  typography: {
    fontFamily: "roboto-regular",
    fontSize: "16px",
    fontWeight: 500,
    width: "99.65%"
  },
  accordionRow: {
    width: "100%"
  },
  categoryTextposition: {
    position: "relative",
    width: "100%"
  },
  tablefirstRowCat: {
    margin: "0px !important",
    ...isMobileVP && {
      padding: "4px 0px 0px 0px !important"
    }
  },
  dropDownIcon: {
    height: "16px",
    width: "16px",
    color: isChannelLineUpPage ? "jet.main" : theme && theme.mode === 'dark' ? "#102641" : "jet.main",
    filter:
        isChannelLineUpPage &&
        "invert(100%) sepia(0%) saturate(7500%) hue-rotate(351deg) brightness(106%) contrast(104%)"
  }
});
